import { Loader2 } from "lucide-react"

interface SubmissionLoaderProps {
  isLoading: boolean
}

export default function SubmissionLoader({ isLoading }: SubmissionLoaderProps) {
  if (!isLoading) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="flex flex-col items-center space-y-4 rounded-lg bg-white p-8 shadow-xl dark:bg-gray-900">
        <Loader2 className="h-8 w-8 animate-spin text-blue-600" />
        <div className="text-center">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">Processing your submission</h3>
          <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
            Wait patiently as we process your submission.
            <br />
            This might take a minute.
          </p>
        </div>
      </div>
    </div>
  )
}
